import React from 'react'
import Grid from '@mui/material/Grid'
import styled from 'styled-components'

import { HeaderText } from './HeaderText'
import { HeaderAction } from './HeaderAction'

const Wrapper = styled(Grid)`
  height: 10rem;
`

const TextAnalysisHeader = () => (
  <Wrapper container direction="column" data-testid="ta-header">
    <HeaderAction />
    <HeaderText />
  </Wrapper>
)

export default React.memo(TextAnalysisHeader)
